// src/routes/index.tsx
import React, { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

// Lazy-loaded pages
const LoginPage = lazy(() => import('../features/auth/pages/LoginPage'));
const ProfilePage = lazy(() => import('../features/auth/pages/ProfilePage'));
const SettingsPage = lazy(() => import('../features/auth/pages/SettingsPage'));
const MapPage = lazy(() => import('../features/map/pages/MapPage'));
const FormListPage = lazy(() => import('../features/forms/pages/FormListPage'));
const FormDetailPage = lazy(() => import('../features/forms/pages/FormDetailPage'));
const FormEditPage = lazy(() => import('../features/forms/pages/FormEditPage'));
const RecordListPage = lazy(() => import('../features/records/pages/RecordListPage'));
const RecordFormPage = lazy(() => import('../features/records/pages/RecordFormPage'));
const RecordDetailPage = lazy(() => import('../features/records/pages/RecordDetailPage'));
const AdminPage = lazy(() => import('../features/admin/pages/AdminPage'));
const OfflineQueuePage = lazy(() => import('../features/offline/pages/OfflineQueuePage'));

// Helper to wrap lazy components with Suspense fallback
const withSuspense = (Component: React.ReactNode) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      {Component}
    </Suspense>
  );
};

// Public routes (no auth required)
export const publicRoutes = [
  { path: '/login', element: withSuspense(<LoginPage />) },
];

// Protected routes (require auth)
export const protectedRoutes = [
  { path: '/map', element: withSuspense(<MapPage />) },
  { path: '/forms', element: withSuspense(<FormListPage />) },
  { path: '/forms/:formId', element: withSuspense(<FormDetailPage />) },
  { path: '/forms/:formId/edit', element: withSuspense(<FormEditPage />) },
  { path: '/records', element: withSuspense(<RecordListPage />) },
  { path: '/records/:formId', element: withSuspense(<RecordListPage />) },
  { path: '/records/:formId/new', element: withSuspense(<RecordFormPage />) },
  { path: '/records/:formId/:recordId', element: withSuspense(<RecordDetailPage />) },
  { path: '/profile', element: withSuspense(<ProfilePage />) },
  { path: '/settings', element: withSuspense(<SettingsPage />) },
  { path: '/admin', element: withSuspense(<AdminPage />) },
  { path: '/offline', element: withSuspense(<OfflineQueuePage />) },
];

// Export a default object matching App.tsx expectations
const routes = {
  public: publicRoutes,
  protected: protectedRoutes,
};

export default routes;